import React from "react";

const TabLoading = () => {
  return <div>Tab Loading</div>;
};

export default TabLoading;
